import React, { useMemo, useState } from 'react';
import { Table, TableBody } from '@mui/material';
import { MemberState } from '../../../../../types/zinantis/members/membersType';
import MembersTableSectionHeader from './MembersTableSectionHeader';
import MemberRow from './MemberRow';
import Icon from '../../../../../muiComponents/Icon';
import Title from '../../../../components/Title';
import Card from '../../../../../muiComponents/Card';

interface MembersTableSectionProps {
    name: string;
    items: MemberState[];
    visibleSegmentName?: boolean;
    visibleNewMember?: boolean;
    totalMembersCount: number;
    headerButtonbar?: React.ReactNode;
}

const MembersTableSection = (props: MembersTableSectionProps) => {
    const {
        name,
        items,
        visibleSegmentName = false,
        visibleNewMember = false,
        totalMembersCount,
        headerButtonbar,
    } = props;

    const [isOpen, setIsOpen] = useState(true);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const membersCountText = useMemo(() => {
        if (items.length === totalMembersCount) return `(${items.length})`;
        return `(${items.length} / ${totalMembersCount})`;
    }, [items.length, totalMembersCount]);

    return (
        <Card>
            <div
                className='flex flex-align-end flex-between padding20'
                style={{ borderBottom: '1px solid var(--border)' }}
            >
                <div className='flex gap-10 flex-align-baseline'>
                    <Title className='text-size-20'>{name}</Title>
                    <span style={{ fontWeight: 300, fontSize: '12px' }}>
                        {membersCountText}
                    </span>
                </div>
                <div className='flex gap-20'>
                    {headerButtonbar && headerButtonbar}
                    <Icon
                        iconName={
                            isOpen ? 'KeyboardArrowUp' : 'KeyboardArrowDown'
                        }
                        className='cursor-pointer'
                        onClick={handleToggle}
                    />
                </div>
            </div>
            <Table size='small'>
                <MembersTableSectionHeader
                    isOpen={isOpen}
                    visibleSegmentName={visibleSegmentName}
                />
                {isOpen ? (
                    <TableBody>
                        {items.map(member => (
                            <MemberRow
                                key={member.id}
                                member={member}
                                visibleSegmentName={visibleSegmentName}
                                visibleNewMember={visibleNewMember}
                            />
                        ))}
                    </TableBody>
                ) : (
                    ''
                )}
            </Table>
        </Card>
    );
};

export default MembersTableSection;
